import { IWorkOrdersPageState } from "interfaces/WorkOrdersPageState";
import {
  IWorkOrdersPagesAC,
  SET_SELECTED_FACILITY
} from "store/actions/workOrdersPage";

const initialState: IWorkOrdersPageState = {
  selectedFacility: null
};

export default (
  state: IWorkOrdersPageState = initialState,
  action: IWorkOrdersPagesAC
): IWorkOrdersPageState => {
  switch (action.type) {
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    default:
      return state;
  }
};
